/* Nothing to show, said in the station's voice, with a way out.
 *
 * An empty state is not an error and must not be dressed as one. Most of the
 * empties on this site are ordinary facts about a small station: nobody is
 * booked on a Thursday, a new resident has no episodes yet, a filter
 * combination has never happened. The copy says which of those it is, and then
 * gives somewhere to go — an empty state with no exit is a dead end with a
 * paragraph on it.
 */

import type { ReactNode } from 'react';

export interface EmptyProps {
  /** The mono line above the sentence. A category, not a sentence. */
  kind?: string;
  /** One sentence. What is not here, stated plainly. */
  title: ReactNode;
  /** Why, and what it means. Optional — some empties need no explaining. */
  children?: ReactNode;
  /** The way out. Buttons or links; the kit does not choose them for you. */
  actions?: ReactNode;
  className?: string;
}

export function Empty({ kind = 'Nothing here', title, children, actions, className }: EmptyProps) {
  return (
    <div className={className ? `empty ${className}` : 'empty'}>
      <div className="mono dim">{kind}</div>
      <p className="t-h3 empty__title">{title}</p>
      {children ? <div className="t-body">{children}</div> : null}
      {actions ? <div className="empty__acts">{actions}</div> : null}
    </div>
  );
}
